const EUR_TO_HUF_RATE = 350;

export const PEPSI_HUF_MAX = 4000;
export const PLAYSTATION_HUF_MAX = 30000;

/**
 * Hot patch: API returns EUR — display as Hungarian forint (Ft).
 * Converts with a fixed rate and caps the displayed amount.
 */
export const formatEurBalanceAsHuf = (availableBalance, maxForint) => {
  if (availableBalance == null || availableBalance === "") {
    return "N/A";
  }

  const eur = Number.parseFloat(String(availableBalance).replace(/,/g, ""));
  if (!Number.isFinite(eur)) {
    return "N/A";
  }

  let huf = Math.floor(eur * EUR_TO_HUF_RATE);
  if (huf > maxForint) {
    huf = maxForint;
  }

  return `Ft: ${huf}`;
};
